(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.setOverlapOffset = this.setOverlapOffset.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.overlapEnabled = this.getAttribute('data-layout') === 'overlap';
      this.stickyEnabled = this.stickyType !== 'none';
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.stickyType === 'always' ||
        this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setOverlapOffset();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      this.mobileMediaQuery.addEventListener('change', this.setOverlapOffset);

      if (this.overlapEnabled && 'ResizeObserver' in window) {
        this.overlapResizeObserver = new ResizeObserver(() => {
          this.setHeaderHeight();
          this.setOverlapOffset();
        });
        this.overlapResizeObserver.observe(this);
      }

      if (!this.stickyEnabled) return;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setOverlapOffset() {
      if (!this.header) return;

      if (this.overlapEnabled) {
        this.header.style.setProperty('--ridevia-header-overlap-offset', `${this.offsetHeight}px`);
      } else {
        this.header.style.removeProperty('--ridevia-header-overlap-offset');
      }
    }

    disconnectedCallback() {
      if (!this.header) return;

      this.mobileMediaQuery?.removeEventListener('change', this.setHeaderHeight);
      this.mobileMediaQuery?.removeEventListener('change', this.setOverlapOffset);
      this.overlapResizeObserver?.disconnect();

      if (!this.stickyEnabled) return;

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, activeObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        activeObserver.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class RideviaTransparentHeaderController {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.section = wrapper.closest('.section-header') || wrapper.closest('.shopify-section') || wrapper.parentElement;
      this.isScrolled = false;
      this.sectionTop = 0;
      this.stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
      this.frame = null;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onMutation = this.onMutation.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
    }

    connect() {
      if (!this.section) return;

      this.updateMetrics();
      this.updateScrollState();
      this.updateInteractionState();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);

      this.mutationObserver = new MutationObserver(this.onMutation);
      this.mutationObserver.observe(this.section, {
        subtree: true,
        attributes: true,
        attributeFilter: ['open', 'class', 'hidden', 'aria-hidden', 'aria-expanded']
      });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.isScrolled) this.scheduleUpdate(true);
        });
        this.resizeObserver.observe(this.wrapper);
      }
    }

    disconnect() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();

      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    }

    getDocumentTop(element) {
      let top = 0;
      let current = element;

      while (current) {
        top += current.offsetTop || 0;
        current = current.offsetParent;
      }

      return top;
    }

    updateMetrics() {
      if (!this.section) return;

      const height = Math.max(0, Math.ceil(this.wrapper.getBoundingClientRect().height));
      this.section.style.setProperty('--ridevia-transparent-header-offset', `${height}px`);
      this.sectionTop = this.getDocumentTop(this.section);
    }

    updateScrollState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const hasPassedHeaderTop = scrollTop > this.sectionTop + 1;
      const isAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      const hasDynamicStickyState =
        this.section.classList.contains('scrolled-past-header') ||
        this.section.classList.contains('shopify-section-header-sticky');
      const nextScrolled =
        this.stickyType !== 'none' &&
        hasPassedHeaderTop &&
        (isAlwaysSticky || hasDynamicStickyState);

      this.isScrolled = nextScrolled;
      this.wrapper.classList.toggle('ridevia-transparent-header--scrolled', nextScrolled);
      this.section.classList.toggle('ridevia-transparent-header--scrolled', nextScrolled);

      if (!nextScrolled) this.updateMetrics();
    }

    isElementVisible(element) {
      if (!element) return false;
      if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;

      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;

      return element.getClientRects().length > 0;
    }

    hasOpenInteraction() {
      const openDetails = this.wrapper.querySelectorAll('details[open]');
      if ([...openDetails].some((details) => this.isElementVisible(details))) return true;

      const expandedLocalizationControls = this.wrapper.querySelectorAll(
        '.localization-form__select[aria-expanded="true"], .disclosure__button[aria-expanded="true"]'
      );
      if ([...expandedLocalizationControls].some((control) => this.isElementVisible(control))) return true;

      const disclosurePanels = this.wrapper.querySelectorAll('.disclosure__list-wrapper');
      if ([...disclosurePanels].some((panel) => this.isElementVisible(panel))) return true;

      const activeHeaderPanels = this.wrapper.querySelectorAll(
        '.search-modal.active, .menu-drawer.active, .mega-menu__content.active, .predictive-search[open]'
      );
      if ([...activeHeaderPanels].some((panel) => this.isElementVisible(panel))) return true;

      const activeCartNotifications = this.section.querySelectorAll(
        'cart-notification.active, .cart-notification.active, cart-notification [aria-hidden="false"].cart-notification'
      );
      if ([...activeCartNotifications].some((notification) => this.isElementVisible(notification))) return true;

      return false;
    }

    updateInteractionState() {
      const interactionOpen = this.hasOpenInteraction();
      this.wrapper.classList.toggle('ridevia-transparent-header--interaction', interactionOpen);
      this.section.classList.toggle('ridevia-transparent-header--interaction', interactionOpen);
    }

    scheduleUpdate(includeMetrics = false) {
      if (this.frame) cancelAnimationFrame(this.frame);

      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (includeMetrics && !this.isScrolled) this.updateMetrics();
        this.updateScrollState();
        this.updateInteractionState();
      });
    }

    onScroll() {
      this.scheduleUpdate(false);
    }

    onResize() {
      this.scheduleUpdate(true);
    }

    onMutation() {
      this.scheduleUpdate(false);
    }

    onSectionUnload(event) {
      if (event.target === this.section || event.target.contains?.(this.section)) {
        this.disconnect();
      }
    }
  }

  const initializeRideviaTransparentHeaders = (root = document) => {
    const wrappers = [];

    if (root instanceof Element && root.matches('[data-ridevia-transparent-home="true"]')) {
      wrappers.push(root);
    }

    if (root.querySelectorAll) {
      wrappers.push(...root.querySelectorAll('[data-ridevia-transparent-home="true"]'));
    }

    wrappers.forEach((wrapper) => {
      if (wrapper.rideviaTransparentHeaderController) return;

      const controller = new RideviaTransparentHeaderController(wrapper);
      wrapper.rideviaTransparentHeaderController = controller;
      controller.connect();
    });
  };

  initializeRideviaTransparentHeaders();

  document.addEventListener('shopify:section:load', (event) => {
    initializeRideviaTransparentHeaders(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
